module.exports = __webpack_public_path__ + "static/img/access-for-all__small.ab5452e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/aside/access-for-all__small.jpg
// module id = lpkB
// module chunks = 1